import {Backdrop} from '../backdrop';
import {MobileMenu} from './mobile-menu';
import {SearchButton} from './search-button';

export class Menu {

    readonly subMenuId = 'header-submenu';
    readonly absoluteMenuId = 'absolute-menu';
    readonly mobileMenuCloseId = 'mobile-menu-close';
    readonly mobileMenuOpenId = 'mobile-menu-open';
    readonly popularProjectsLinkId = 'popular-projects-link';
    readonly mobileMenu = new MobileMenu();
    readonly searchButton = new SearchButton();


    constructor(private backdrop: Backdrop) {
        backdrop.addOnClickCallback(this.close.bind(this));
    }

    public toggle() {
        if (this.getSubmenuElement().style.opacity === '1') {
            this.close();

            return false;
        }
        this.open();

        return false;
    }

    public open() {
        const subMenu = this.getSubmenuElement();
        subMenu.style.height = 'auto';
        subMenu.style.opacity = '1';

        const absoluteMenu = this.getAbsoluteElement();
        absoluteMenu.classList.add('bg-white');
        absoluteMenu.classList.add('shadow-lg');
        absoluteMenu.classList.add('opening');
        absoluteMenu.addEventListener('animationend', this.opened.bind(this), {once: true});

        const popularProjectsLink = this.getPopularProjectsLink();

        popularProjectsLink?.classList.remove('arrow-bottom');
        popularProjectsLink?.classList.add('arrow-top');

        this.getMobileCloseButton().classList.remove('d-none');
        this.getMobileOpenButton().classList.add('d-none');
        this.searchButton.hideOnMobile();
        this.backdrop.show();
    }

    private opened() {
        const absoluteMenu = this.getAbsoluteElement();
        absoluteMenu.classList.remove('opening');
    }

    public close() {
        const absoluteMenu = this.getAbsoluteElement();
        absoluteMenu.classList.add('closing');
        absoluteMenu.classList.remove('open');
        absoluteMenu.addEventListener('animationend', this.closed.bind(this), {once: true});
        this.getMobileCloseButton().classList.add('d-none');
        this.getMobileOpenButton().classList.remove('d-none');

        const popularProjectsLink = this.getPopularProjectsLink();

        popularProjectsLink?.classList.remove('arrow-top');
        popularProjectsLink?.classList.add('arrow-bottom');

        this.searchButton.show();

        this.backdrop.hide();
    }

    private closed() {
        const subMenu = this.getSubmenuElement();
        subMenu.style.height = '0';
        subMenu.style.opacity = '0';

        const absoluteMenu = this.getAbsoluteElement();
        absoluteMenu.classList.remove('bg-white');
        absoluteMenu.classList.remove('shadow-lg');
        absoluteMenu.classList.remove('closing');
    }

    private getSubmenuElement(): HTMLElement {
        let subMenu = document.getElementById(this.subMenuId);
        if (subMenu instanceof HTMLElement) {
            return subMenu;
        }
        console.error('Could not find the sub menu!');
    }

    private getAbsoluteElement(): HTMLElement {
        let absoluteMenu = document.getElementById(this.absoluteMenuId);
        if (absoluteMenu instanceof HTMLElement) {
            return absoluteMenu;
        }
        console.error('Could not find the absolute menu!');
    }

    private getMobileCloseButton(): HTMLElement {
        let mobileCloseButton = document.getElementById(this.mobileMenuCloseId);
        if (mobileCloseButton instanceof HTMLElement) {
            return mobileCloseButton;
        }
        console.error('Could not find the close button!');
    }

    private getMobileOpenButton(): HTMLElement {
        let mobileOpenButton = document.getElementById(this.mobileMenuOpenId);
        if (mobileOpenButton instanceof HTMLElement) {
            return mobileOpenButton;
        }
        console.error('Could not find the open button!');
    }

    private getPopularProjectsLink(): HTMLElement {
        let popularProjectsLink = document.getElementById(this.popularProjectsLinkId);
        if (popularProjectsLink instanceof HTMLElement) {
            return popularProjectsLink;
        }

        return null;
    }
}
